import { configureStore } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query'
import '@/store/api/authApi'
import '@/modules/agencies/api/agenciesApi'
import { baseApi } from '@/store/api/baseApi'
import { agenciesUiReducer } from '@/store/slices/agenciesUiSlice'
import { agencyUsersUiReducer } from '@/store/slices/agencyUsersUiSlice'
import { authReducer } from '@/store/slices/authSlice'

export const store = configureStore({
  reducer: {
    auth: authReducer,
    agenciesUi: agenciesUiReducer,
    agencyUsersUi: agencyUsersUiReducer,
    [baseApi.reducerPath]: baseApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(baseApi.middleware),
})

setupListeners(store.dispatch)

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
